module.exports = __webpack_public_path__ + "img/liXiang.843c4b8a.jpg";